export default __webpack_public_path__ + "1901e0b279402190df1ac64530e09ad1.woff";